import { render, staticRenderFns } from "./VirtualEventPromotionDialog.vue?vue&type=template&id=0753b762&scoped=true&"
import script from "./VirtualEventPromotionDialog.vue?vue&type=script&lang=ts&"
export * from "./VirtualEventPromotionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./VirtualEventPromotionDialog.vue?vue&type=style&index=0&id=0753b762&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0753b762",
  null
  
)

export default component.exports